<template>

    <div class="form-group">
        <label v-if="hideLabel === false" for="">{{ element.display_name }}</label>
        <input type="text" v-bind="inputAttributes" class="form-control" v-model="element.value" @input="handleInput">
        <div class="d-block invalid-feedback" v-if="error">{{ error }}</div>
    </div>

</template>

<script>

export default {

    name: 'PersonalizedGameEditorString',

    props: {
        value: Object,
        location: String,
        hideLabel: Boolean
    },

    data() {
        return {
            eventHub: window.eventHub,
            element: this.value,
            error: null
        }
    },

    computed: {
        elementLocation() {
            if (this.location) {
                return this.location + '.' + this.element.name;
            }
            return this.element.name
        },
        inputAttributes() {
            let attrs = {
                minlength: this.element.min_length,
            };
            if (this.element.max_length > 0) {
                attrs.maxlength = this.element.max_length;
            }
            return attrs;
        }
    },

    mounted() {
        this.eventHub.$on('personalized-games-update-errors', errors => {
            if (errors[this.elementLocation] !== undefined) {
                this.error = errors[this.elementLocation];
            } else {
                this.error = null;
            }
        });
    },

    methods: {
        handleInput (e) {
            this.$emit('input', this.element)
        }
    }

}
</script>

<style scoped>

</style>
